















import { defineComponent } from '@vue/composition-api';
import TtamALink from '@/components/common/a-link/a-link.vue';
import empty1 from '@tt4b/ttam-assets/src/images/creative/empty-1.png';
import empty2 from '@tt4b/ttam-assets/src/images/creative/empty-2.png';
import EmptyDataIcon from '@tt4b/ttam-assets/src/images/empty-data.svg';
import FilterEmptyIcon from '@tt4b/ttam-assets/src/images/creative/filter-empty.svg';

const name = 'ttam-library-list-empty-lite';

export default defineComponent({
  name,
  components: { FilterEmptyIcon },
  props: {},
  setup() {
    return {};
  },
});
